import Accordion from '@/components/Accordion/Accordion'
import ProgramCard from '@/components/ProgramCard/ProgramCard'
import { UtilityProgram } from '@/types/utilityProgram'
import ExpandFade from '@/components/Animations/ExpandFade/ExpandFade'
import EmptyMailbox from '@/app/img/empty-mailbox.svg'
import Text from '@/components/Text'
import { match } from 'ts-pattern'

type Props = {
  programs: UtilityProgram[]
  title: string
  enrolled?: boolean
  initialState?: 'open' | 'closed'
  show?: boolean // New simple prop
}

export default function ProgramCardAccordion(props: Props) {
  const shouldShow = props.show ?? true

  const content = () =>
    match({ hasPrograms: props.programs.length > 0 })
      .with({ hasPrograms: false }, () => (
        <div className="flex flex-col gap-2 p-4 text-center bg-[#FBF6FF] rounded-2xl">
          <img src={EmptyMailbox} className="size-36 mx-auto" />
          <Text variant="h3">No Available Programs</Text>
          <Text variant="body2" className="text-base-grey-900">
            Come back soon as we're always looking for new programs for this
            device!
          </Text>
        </div>
      ))
      .otherwise(() => (
        <div className={'flex flex-col gap-2'}>
          {props.programs.map((program) => (
            <ProgramCard
              program={program}
              key={program.name}
              enrolled={props.enrolled}
            />
          ))}
        </div>
      ))

  return (
    <ExpandFade
      show={shouldShow}
      animationKey={`program-card-accordion-${props.title.toLowerCase()}`}
      className="w-full"
    >
      <Accordion title={props.title} initialState={props?.initialState}>
        {content()}
      </Accordion>
    </ExpandFade>
  )
}
